import * as types from '../actions/tabletSessionsAction';

const initialState = {
  data: [],
  limit: '20',
  page: 0,
  totalResults: 0,
  loading: false,
};

const tabletSessionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_TABLET_SESSIONS_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.GET_TABLET_SESSIONS:
      return {
        ...state,
        loading: true,
      };

    case types.GET_TABLET_SESSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalResults: action.payload.length,
      };

    case types.GET_TABLET_SESSIONS_ERROR:
      return {
        ...state,
        loading: false,
      };

    case types.RESET_TABLET_SESSIONS_STORE:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default tabletSessionsReducer;
